class GeoFeatureClusteredName {
    constructor(id, coordinates, name, timestamp) {
        this.id = id;
        this.coordinates = coordinates;
        this.name = name;
        this.timestamp = timestamp;
    }
}
export default GeoFeatureClusteredName;
